import { render, staticRenderFns } from "./ReportTemplateSelector.vue?vue&type=template&id=13cc2fc2&"
import script from "./ReportTemplateSelector.vue?vue&type=script&lang=js&"
export * from "./ReportTemplateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports